var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.966 4.25882C33.1089 3.72535 32.7923 3.17702 32.2589 3.03407L23.5655 0.704703C23.0321 0.561761 22.4837 0.878344 22.3408 1.41181C22.1978 1.94528 22.5144 2.49361 23.0479 2.63655L30.7753 4.70711L28.7047 12.4345C28.5618 12.968 28.8784 13.5163 29.4118 13.6593C29.9453 13.8022 30.4936 13.4856 30.6366 12.9522L32.966 4.25882ZM1.32312 22.866L32.5 4.86603L31.5 3.13397L0.32312 21.134L1.32312 22.866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTopArrow);
export default __webpack_public_path__ + "static/media/mobileTopArrow.85b2289c542c0b3197eb9ccf22ebced5.svg";
export { ForwardRef as ReactComponent };